export const ADMIN_ROLE = 'Admin'
export const EDITOR_ROLE = 'Editor'
export const VIEWER_ROLE = 'Viewer'

export const EVENT_TYPES = {
  INCIDENT: "Incident",
};

export const MEDIA_TYPES = {
  IMAGE: "image",
  VIDEO: "video",
};